import { useTheme } from '@algoan/deep-dive/theme';
import { ComponentProps } from '@algoan/deep-dive/model';

export interface PendingIconProps extends ComponentProps {
  color?: string;
}

export const PendingIcon = ({ color, ...props }: PendingIconProps): JSX.Element => {
  const theme = useTheme();
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="5" cy="5" r="5" fill={color ?? theme.orangeWarning} />
      <path d="M5 1.66699V5.41699L2.5 6.66699" stroke="white" />
    </svg>
  );
};
